import './App.css';
import MovieDetailsFetcher from './MovieDetailsFetcher';

function App() {
  return (
    <div className="App">
      <MovieDetailsFetcher />
      <div className="footer">
        Learning Project by Sandeep Lakka
      </div>
    </div>
  );
}

export default App;
